import { env } from '../config/env';

export async function fetchInvitePreview(token) {
  const response = await fetch(
    `${env.apiBaseUrl}/auth/invite?token=${encodeURIComponent(token)}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    return {
      valid: false,
      status: payload.status || 'invalid',
      message: payload.message,
      ...payload,
    };
  }
  return payload;
}

export async function completeInviteSetPassword({ token, password, confirmPassword }) {
  const response = await fetch(`${env.apiBaseUrl}/auth/invite/set-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, password, confirmPassword }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.message || 'Unable to set password.');
  }
  return payload;
}
